
define(function (require) {

    var MultiSelectionDropdownViewController = require('web-agent-components/MultiSelectionDropdownViewController');

    var ButtonMultiSelectionDropdownViewController = MultiSelectionDropdownViewController.extend({
        ControllerName : "ButtonMultiSelectionDropdownViewController",

        LPViewMap : {
        },

        initialize : function (constructorData) {
        },

        events : function () {
        },

        render : function () {
        }
    });

    ButtonMultiSelectionDropdownViewController.prototype.getConfiguration = function() {
        var configuration = {
            templateFile : "LP_button_dropdown.html",
            focusedViewClass : ".lpview_focus_element"
        };
        return configuration;
    };


    return ButtonMultiSelectionDropdownViewController;

});
